<template>
  <div class="product-slider__content">
    <div ref="sliderContainer" class="product-slider__container">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) of productsList"
          :key="`product-slide-${index}`"
          class="product-slide"
          data-entity="items-row"
        >
          <productItem
            :product-id="item.id"
            :product-name="item.name"
            :product-node="item.node"
            :product-code="item.code"
            :detail-page-url="item.detailPageUrl"
            :product-img="item.picture"
            :product-price="item.price"
            :unit="item.unit"
            :product-package="item.package"
            :discount="discount"
          />
        </div>
      </div>
      <button class="arrow arrow-prev" :class="{hidden: hideNavigationButtons}" />
      <button class="arrow arrow-next" :class="{hidden: hideNavigationButtons}" />
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import productItem from './components/productItem';

export default {
  name: 'product-slider',

  components: {
    productItem,
  },

  props: {
    productsList: {
      type: Array,
      default: () => [],
    },
    discount: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    swiper: {},
    swiperOptions: {
      slideClass: 'product-slide',
      speed: 800,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        prevEl: '.product-slider__container .arrow-prev',
        nextEl: '.product-slider__container .arrow-next',
      },
      breakpoints: {
        0: {
          spaceBetween: 25,
          slidesPerView: 1,
        },
        480: {
          spaceBetween: 15,
          slidesPerView: 2,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1025: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1201: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: '.product-slider__paggination',
        clickable: true,
        type: 'bullets',
      },
    },
  }),

  computed: {
    hideNavigationButtons() {
      if (window.innerWidth < 1201) return this.productsList.length < 4;
      return this.productsList.length < 5;
    },
  },

  watch: {
    productsList() {
      this.swiperInit(this.swiperOptions);
      this.$nextTick(() => {
        window.loyaltyProgramInit();
        window.addHandlerClickOnCompareIcon();
        window.setActiveCompareIcons();

        window.setActiveFavoriteIcons();
        window.addHandlerClickOnFavoriteIcon();
      });
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.swiperInit(this.swiperOptions);
      window.loyaltyProgramInit();
      window.addHandlerClickOnCompareIcon();
      window.addHandlerClickOnFavoriteIcon();
    });
  },

  methods: {
    swiperInit(options) {
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy();
      }

      this.$nextTick(() => {
        this.swiper = new Swiper(this.$refs.sliderContainer, options);
        this.swiper.on('slideChange', () => {
          this.$emit('slideChange', this.swiper.realIndex);
        });
        this.swiper.slideToLoop(this.index);

        // this.checkMoreBullets();

        if (this.forceUpdate) {
          setTimeout(() => {
            this.swiperUpdate();
          }, 500);
        }
      });

      window.setBasketButtons();
    },

    swiperUpdate() {
      if (!this.swiper) return;

      if (this.swiper.update) {
        this.swiper.update();
      }

      // this.checkMoreBullets();
    },
  },
};
</script>
